import React from 'react'

export function StatusPill({ tone = 'neutral', children }) {
  return <span className={`v2-pill v2-pill-${tone}`}>{children}</span>
}

export function MetricCard({ label, value, detail, tone = 'neutral' }) {
  return (
    <article className={`v2-metric v2-metric-${tone}`}>
      <span>{label}</span>
      <strong>{value}</strong>
      {detail ? <p>{detail}</p> : null}
    </article>
  )
}

export function Section({ eyebrow, title, description, actions, children, className = '' }) {
  return (
    <section className={`v2-section ${className}`.trim()}>
      <div className="v2-section-head">
        <div>
          {eyebrow ? <p className="v2-kicker">{eyebrow}</p> : null}
          <h2>{title}</h2>
          {description ? <p>{description}</p> : null}
        </div>
        {actions ? <div className="v2-section-actions">{actions}</div> : null}
      </div>
      {children}
    </section>
  )
}

export function LoadingBlock({ label = 'Loading workspace...' }) {
  return (
    <div className="v2-loading">
      <span />
      <p>{label}</p>
    </div>
  )
}

export function EmptyState({ title, description, action }) {
  return (
    <div className="v2-empty">
      <strong>{title}</strong>
      {description ? <p>{description}</p> : null}
      {action || null}
    </div>
  )
}

export function SettingExplainer({ label, value, description, recommended, impact, scope, risk = 'Low' }) {
  return (
    <article className="v2-setting-card">
      <div className="v2-setting-main">
        <span>{label}</span>
        <strong>{value || 'Not set'}</strong>
        <p>{description}</p>
      </div>
      <dl className="v2-setting-meta">
        <div>
          <dt>Recommended</dt>
          <dd>{recommended}</dd>
        </div>
        <div>
          <dt>Impact</dt>
          <dd>{impact}</dd>
        </div>
        <div>
          <dt>Scope</dt>
          <dd>{scope}</dd>
        </div>
        <div>
          <dt>Risk</dt>
          <dd>{risk}</dd>
        </div>
      </dl>
    </article>
  )
}
